export const ALLOW_BOOKINGS_THROUGH_FOOTFALL = false;
